"use client";

import { cn } from "@/lib/utils";
import React from "react";
import MobileContainer from "./mobile/MobileContainer";
import DesktopContainer from "./desktop/DesktopContainer";
import { useUI } from "../context/UIProvider";

type Props = {
  className?: string;
};

export const linearGradientContainer = {
  border: "1px solid rgba(255, 255, 255, 0.53)",
  background:
    "linear-gradient(109deg, #EAEFF3 25.62%, #C2D4E1 36.25%, #FFF 45.42%, #D4DEE5 51.8%, #ABBDC8 60.62%, #BCCAD7 69.43%)",
};

const GondolaChallengePage: React.FC<Props> = ({ className }) => {
  const { isLessThanLg } = useUI();

  return (
    <div className={cn("", className)}>
      {isLessThanLg ? <MobileContainer /> : <DesktopContainer />}
    </div>
  );
};

export default GondolaChallengePage;
